import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { getPlatformStats } from "@/services/courseService";
import { useCountUp } from "@/my_components/Common/useCountUp";

const TrustBar = () => {
  const { t } = useTranslation("home");
  const [stats, setStats] = useState(null);
  const [inView, setInView] = useState(false);
  const statsRef = useRef(null);

  useEffect(() => {
    getPlatformStats()
      .then((res) => setStats(res.data))
      .catch(() => {});
  }, []);

  // useCountUp only starts animating once `active` (here, `inView`) flips true, so the counters
  // need to be bumped from "not in view" once the section scrolls into view -- fetching the
  // stats alone isn't enough to trigger the roll-up animation.
  useEffect(() => {
    const el = statsRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.4 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const items = [
    { value: stats?.total_courses ?? 35, suffix: "+", label: t("trustBar.courses", "Free courses"), icon: "feather-book-open" },
    { value: stats?.total_students ?? 5000, suffix: "+", label: t("trustBar.students", "Students learning"), icon: "feather-users" },
    { value: stats?.total_categories ?? 8, suffix: "", label: t("trustBar.tracks", "Skill tracks"), icon: "feather-layers" },
    { value: stats?.total_instructors ?? 12, suffix: "+", label: t("trustBar.instructors", "Real instructors"), icon: "feather-award" },
  ];

  return (
    <div className="rbt-trust">
      <div className="container">
        <div className="rbt-trust__stats" ref={statsRef}>
          {items.map((item) => (
            <TrustStat key={item.label} item={item} active={inView} />
          ))}
        </div>
      </div>
    </div>
  );
};

// Split out so each stat can call useCountUp on its own -- hooks can't be called inside the
// parent's .map() directly.
const TrustStat = ({ item, active }) => {
  const count = useCountUp(item.value, active);
  return (
    <div className="rbt-trust__stat">
      <span className="rbt-trust__stat-icon">
        <i className={item.icon}></i>
      </span>
      <span className="rbt-trust__stat-copy">
        <strong>
          {count}
          {item.suffix}
        </strong>
        <span className="rbt-trust__stat-label">{item.label}</span>
      </span>
    </div>
  );
};

export default TrustBar;
